import { createAction } from 'redux-act';

const createActionCreator = moduleName => actionDescription => (
  createAction(`${moduleName}/${actionDescription}`)
);

export { createActionCreator };
